import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { trackingConsentModeBackend } from './tracking-consent-mode.backend';
import { trackingConsentModeReducer } from './tracking-consent-mode.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('trackingConsentMode', trackingConsentModeReducer),
    BackendModule.forFeature('trackingConsentMode', trackingConsentModeBackend),
  ],
})
export class DatastoreTrackingConsentModeModule {}
